import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

const sharedMonacoEditorRestriction: monaco.editor.IEditorOptions = {
    // Turning off quick suggestions will break the # character triggering in handlebar mode
    quickSuggestions: true,
    quickSuggestionsDelay: 250
}

export const singleLineMonacoEditorRestriction: monaco.editor.IEditorOptions = {
    lineNumbers: 'off',
    lineNumbersMinChars: 0,
    overviewRulerBorder: false,
    hideCursorInOverviewRuler: true,
    lineDecorationsWidth: 0,
    glyphMargin: false,
    folding: false,
    scrollBeyondLastColumn: 0,
    scrollbar: {
        horizontal: 'hidden',
        vertical: 'hidden',
        // avoid can not scroll page when hover monaco
        alwaysConsumeMouseWheel: false,
    },
    // disable `Find`
    find: {
        addExtraSpaceOnTop: false,
        autoFindInSelection: 'never',
        seedSearchStringFromSelection: "never",
    },
    minimap: { enabled: false },
    // avoid highlight hover word
    occurrencesHighlight: false,
    cursorStyle: 'line-thin',
    // hide current row highlight grey border
    // see: https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.ieditoroptions.html#renderlinehighlight
    renderLineHighlight: 'none',
    contextmenu: false,
    // default selection is rounded
    roundedSelection: false,
    hover: {
        // unit: ms
        // default: 300
        delay: 100,
    },
    acceptSuggestionOnEnter: 'on',
    // auto adjust width and height to parent
    // see: https://github.com/Microsoft/monaco-editor/issues/543#issuecomment-321767059
    // if monaco is inside a table, hover tips or completion may casue table body scroll
    fixedOverflowWidgets: true,
    ...sharedMonacoEditorRestriction
};

export const multiLineMonacoEditorRestriction: monaco.editor.IEditorOptions = {
    lineNumbers: 'on',
    lineNumbersMinChars: 5,
    overviewRulerBorder: true,
    hideCursorInOverviewRuler: false,
    lineDecorationsWidth: 10,
    glyphMargin: false,
    folding: true,
    scrollBeyondLastColumn: 5,
    scrollbar: {
        horizontal: 'auto',
        vertical: 'auto',
        alwaysConsumeMouseWheel: true
    },
    find: {
        addExtraSpaceOnTop: false,
        autoFindInSelection: 'multiline',
        seedSearchStringFromSelection: "selection",
    },
    minimap: { enabled: true },
    occurrencesHighlight: true,
    cursorStyle: 'line',
    renderLineHighlight: 'all',
    contextmenu: false,
    roundedSelection: true,
    acceptSuggestionOnEnter: 'on',
    fixedOverflowWidgets: false,
    quickSuggestions: {
        strings: true,
        comments: false,
        other: false
    },
    ...sharedMonacoEditorRestriction
}

export const monacoEditorRestriction: monaco.editor.IEditorOptions = {
    ...singleLineMonacoEditorRestriction,
    scrollBeyondLastLine: false,
    overviewRulerLanes: 0,
    wrappingStrategy: 'advanced',
    fontSize: 18,
    lineHeight: 21,
    fontWeight: 'normal',
    fontFamily: "CourierPrime-Regular"
}

export const singleLineDiffMonacoEditorRestriction: monaco.editor.IDiffEditorConstructionOptions = {
    wordWrap: 'off',
    lineNumbers: 'off',
    lineNumbersMinChars: 0,
    overviewRulerLanes: 0,
    overviewRulerBorder: false,
    hideCursorInOverviewRuler: true,
    lineDecorationsWidth: 0,
    glyphMargin: false,
    folding: false,
    scrollBeyondLastColumn: 0,
    scrollbar: {
        horizontal: 'hidden',
        vertical: 'hidden',
        // avoid can not scroll page when hover monaco
        alwaysConsumeMouseWheel: false,
        verticalSliderSize: 0
    },
    // disable `Find`
    find: {
        addExtraSpaceOnTop: false,
        autoFindInSelection: 'never',
        seedSearchStringFromSelection: "never",
    },
    minimap: { enabled: false },
    // avoid highlight hover word
    occurrencesHighlight: false,
    cursorStyle: 'line-thin',
    // hide current row highlight grey border
    // see: https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.ieditoroptions.html#renderlinehighlight
    renderLineHighlight: 'none',
    contextmenu: false,
    // default selection is rounded
    roundedSelection: false,
    hover: {
        // unit: ms
        // default: 300
        delay: 100,
    },
    // auto adjust width and height to parent
    // see: https://github.com/Microsoft/monaco-editor/issues/543#issuecomment-321767059
    automaticLayout: true,
    // if monaco is inside a table, hover tips or completion may casue table body scroll
    fixedOverflowWidgets: true
}